import { API } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export async function generateCostCenterOlPayments(ids: number[]) {
  return restApiClient.url(API.centerOlPayments.generateCostPayment.url).post({ ids })
}
